import consola from 'consola';

export const logError = (error: any) => {
  consola.error(error);
};

export const logApiError = (errorCode: string[], apiUrl: string, stacktrace: string | undefined) => {
  consola.error(errorCode, apiUrl, stacktrace);
};
